module.exports = __webpack_public_path__ + "static/netWorthInfo-e7a743f6c700f3a27408963842781017.svg";